import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const EditPresentationInfo = ({
	isDownLoad,
	onClose,
	collectionTitle,
	selectedProductIds,
	setPresentationInfo,
	presentationInfo,
	entityType = 'COLLECTION'
}) => {
	const [collectionName, setCollectionName] = useState('');
	const [seasonName, setSeasonName] = useState('');
	const [market, setMarket] = useState('');
	const [, setSelectedIds] = useState([]);
	const [isCheckedMoodboard, setIsCheckedMoodboard] = useState(false);
	const [errors, setErrors] = useState({
		collectionNameError: ''
	});
	let { id } = useParams();

	useEffect(() => {
		document.getElementById('testModal').focus();
	}, []);

	useEffect(() => {
		let collectionName = presentationInfo?.presentationName
			? presentationInfo?.presentationName
			: collectionTitle;
		setCollectionName(collectionName);
		setMarket(presentationInfo?.market);
		setSeasonName(presentationInfo?.season);
		setSelectedIds(selectedProductIds);
	}, [collectionTitle, selectedProductIds]);

	const onSubmit = async () => {
		if (collectionName !== '') {
			let body = {
				entityId: id,
				entityType: entityType,
				presentationName: collectionName,
				market: market,
				season: seasonName,
				withMoodboard: isCheckedMoodboard
			};
			await ApiClient.POST('savePresentationSequence', body)
				.then(() => {
					// onShareClick()
					setPresentationInfo(body);
					onClose();
				})
				.catch((error) => {
					toastError(error.response.data.message);
				});
		} else {
			setErrors({ collectionNameError: 'Input a Collection name' });
		}
	};

	return (
		<Modal show={isDownLoad} onHide={onClose} className="presentation-modal" id="testModal">
			<Modal.Header closeButton>
				<Modal.Title>
					<span className="semibold-16">Edit Presentation Info</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<label>Collection</label>
								<input
									type="text"
									autoComplete="off"
									name="collectionName"
									className={`bg-gray-light border-0 ${
										errors.collectionNameError ? 'error2' : ''
									}`}
									id="myTextField"
									value={collectionName}
									onClick={() => {
										document.getElementById('myTextField').focus();
									}}
									onChange={(e) => {
										setErrors({ ...errors, collectionNameError: '' });
										setCollectionName(e.target.value);
									}}
									placeholder="Type Collection name"
								/>
								{errors.collectionNameError ? (
									<span className="error">{errors.collectionNameError}</span>
								) : (
									''
								)}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label>Season name</label>
								<input
									type="text"
									autoComplete="off"
									name="seasonName"
									className="bg-gray-light border-0"
									value={seasonName}
									onChange={(e) => setSeasonName(e.target.value)}
									placeholder="Type season"
								/>{' '}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group mb-0">
								<label>Market</label>
								<input
									type="text"
									autoComplete="off"
									name="market"
									className="bg-gray-light border-0"
									value={market}
									onChange={(e) => setMarket(e.target.value)}
									placeholder="Type market"
								/>{' '}
							</div>
						</div>
						<div className="all-checkbox bg-gray-light select-all-designs col-md-6">
							<div className="custom-chekbox">
								<div className="form-group m-0 mt-3">
									<input
										id="isMoodboard"
										type="checkbox"
										value={isCheckedMoodboard}
										onChange={() => setIsCheckedMoodboard(!isCheckedMoodboard)}
									/>
									<label htmlFor="isMoodboard" className="m-0">
										<span className="align-middle">Moodboard</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button className="presentation-btn size32" variant="primary" onClick={onSubmit}>
					Submit
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
export default EditPresentationInfo;
